import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-8 mx-auto" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Educational video", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " Please watch this short (3:00) introductory video. ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " It provides more background on defined benefit transfers, the advice process and what you need to consider. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_YouTube = _resolveComponent("YouTube")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createVNode(_component_YouTube, {
          src: _ctx.videoUrl,
          onStateChange: _ctx.onStateChanged,
          ref: "youtube",
          class: "w-100",
          vars: _ctx.playerVars
        }, null, 8, ["src", "onStateChange", "vars"]),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("button", {
            type: "button",
            class: "btn btn-primary mt-4",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSkipVideoClicked && _ctx.onSkipVideoClicked(...args)))
          }, " I want to skip the video ", 512), [
            [_vShow, !_ctx.videoHasEnded]
          ]),
          _withDirectives(_createElementVNode("button", {
            type: "button",
            class: "btn btn-primary mt-4",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onContinueClicked && _ctx.onContinueClicked(...args)))
          }, " Begin Questions ", 512), [
            [_vShow, _ctx.videoHasEnded]
          ])
        ])
      ])
    ])
  ]))
}